<template>
  <div id="embed_video">
    <div v-if="!show404" class="player_video">
      <!-- <uep-player v-if='!isLoading&&crypttext' :url="crypttext" :query="query" @readyPlayer="readyPlayer"></uep-player> -->
      <iframe
        allow="fullscreen;autoplay"
        mozallowfullscreen="true"
        frameborder="0"
        webkitallowfullscreen="true"
        v-if="!isLoading && cryptedURL"
        :src="cryptedURL"
      ></iframe>
    </div>
    <page404 v-if="show404"></page404>
  </div>
</template>
<script>
import LoadingScreen from "./Loading.vue";
import Page404 from "./404.vue";
export default {
  name: "embed_video",
  components: { LoadingScreen, Page404 },
  data() {
    return {
      cryptedURL: null,
      skin: "",
      plugin: "",
      query: {},
      isLoading: true,
      show404: false
    };
  },
  methods: {
    fetchVideoEmbed() {
      let self = this;
      this.$service
        .getCryptedUrl({
          v:this.$route.params.id,
          query:this.$route.query
        })
        .then(
          function(resp) {
            self.query = Object.assign(
              { skin: resp.data.skin, plugin: resp.data.plugin },
              this.$route.query
            );
            self.cryptedURL = resp.data.cryptedURL;
            self.skin = resp.data.skin;
            self.plugin = resp.data.plugin;
            self.isLoading = false;
            if (!resp.data.exist) {
              self.$router.push({ name: "Page404" });
            }
          }.bind(this)
        )
        .catch(
          function(error) {
            console.log('error',error)
            self.isLoading = false;
            self.show404 = true;
          }.bind(this)
        );
    }
  },
  created() {
    this.fetchVideoEmbed();
  }
};
</script>
<style lang="scss">
.player_video {
  height: 100vh;
  display: flex;
  flex-direction: column;
  iframe {
    min-height: 100vh;
    aspect-ratio: 16/9;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EmbedVideo.vue